export default __webpack_public_path__ + "static/media/clothTexture.8474d916.png";